import React from 'react';
import Tooltip from './Tooltip';

export const withTooltipWrapper = (content: JSX.Element, tooltipProps: { message: string; title?: string }) =>
  tooltipProps.message ? (
    <Tooltip className="custom-tooltip-v2" {...tooltipProps}>
      <div>{content}</div>
    </Tooltip>
  ) : (
    content
  );
